export default {
  props: ["lazyImage", "fullImage", "hasNext", "hasPrev"],
  data() {
    return {
      imageDimensions: {
        lazy: {
          width: null,
          height: null,
        },
        full: {
          width: null,
          height: null,
        },
      },
      loadingComplete: false,
    };
  },
  mounted() {
    this.loadImageDimensions(this.lazyImage, (width, height) => {
      this.imageDimensions.lazy.width = width;
      this.imageDimensions.lazy.height = height;
    });
  },
  methods: {
    close() {
      this.$emit("close");
    },
    next() {
      this.$emit("next");
    },
    prev() {
      this.$emit("prev");
    },
    download() {
      this.$emit("download");
    },
    loadImageDimensions(imageData, callback) {
      let img = new Image();

      img.onload = () => {
        const imageHeight = img.height;
        const imageWidth = img.width;

        const containerHeight = this.$refs.imageContainer.offsetHeight;
        const containerWidth = this.$refs.imageContainer.offsetWidth;

        // try max width
        let scalingFactor = 0,
          scaledWidth = 0,
          scaledHeight = 0,
          fit = false;
        scalingFactor = containerWidth / imageWidth;
        scaledWidth = Math.round(imageWidth * scalingFactor);
        scaledHeight = Math.round(imageHeight * scalingFactor);
        fit = scaledWidth <= containerWidth && scaledHeight <= containerHeight;

        if (fit) {
          return callback(scaledWidth, scaledHeight);
        }

        scalingFactor = containerHeight / imageHeight;
        scaledWidth = Math.round(imageWidth * scalingFactor);
        scaledHeight = Math.round(imageHeight * scalingFactor);
        fit = scaledWidth <= containerWidth && scaledHeight <= containerHeight;

        if (fit) {
          return callback(scaledWidth, scaledHeight);
        }

        throw Error("No Fit");
      };

      img.src = imageData;
    },
  },
  watch: {
    fullImage(nextValue) {
      this.loadingComplete = false;

      this.loadImageDimensions(nextValue, (width, height) => {
        this.imageDimensions.full.width = width;
        this.imageDimensions.full.height = height;
        this.loadingComplete = true;
      });
    },
    lazyImage(nextValue) {
      this.loadImageDimensions(nextValue, (width, height) => {
        this.imageDimensions.lazy.width = width;
        this.imageDimensions.lazy.height = height;
      });
    },
  },
};
